import React from "react";
import clsx from "clsx";
import type { ExtraType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import AddToBasket from "../../../common/AddToBasket";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { trackOptionsBasketHomeChargerAdd, trackOptionsBasketHomeChargerRemove } from "../../../../../utils/tracking";
import cardStyles from "../../../../../../shared-components/css-modules/toyota/molecules/Card.module.scss";
import styles from "./Charging.module.scss";
import { useCarConfigDispatch, useCarConfigSelector } from "../../../../../redux/store";
import { addExtra, removeExtra } from "../../../../../redux/slices/CarConfigBasketSlice";
import useAphHomeCharger from "../../../../../hooks/useAphHomeCharger";
import Price from "../../../common/price/Price";
import { getCarDBAssetSrcSet } from "../../../../../../../shared-logic/utils/imageUtils";
import { useCarConfigLabel } from "../../../../../utils/labelUtils";
import { addNotification } from "../../../../../../../../common-deprecated/redux/actions/NotificationActions";

const HomeCharger: React.FC<ExtraType> = (homeCharger) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const { image, name, description, price, footNote } = homeCharger;
    const dispatch = useCarConfigDispatch();
    const { isSelected } = useAphHomeCharger(homeCharger);
    const notificationHomechargerAdded = useCarConfigLabel("carConfigA11yHomechargerAdded", {
        homecharger: homeCharger.name,
    });
    const notificationHomechargerRemoved = useCarConfigLabel("carConfigA11yHomechargerRemoved", {
        homecharger: homeCharger.name,
    });

    const handleClick = (): void => {
        if (isSelected) {
            trackOptionsBasketHomeChargerRemove();
            dispatch(removeExtra({ extra: homeCharger }));
            dispatch(
                addNotification([
                    {
                        title: notificationHomechargerRemoved,
                        srOnly: true,
                    },
                ]),
            );
        } else {
            trackOptionsBasketHomeChargerAdd();
            dispatch(addExtra({ extra: homeCharger, automatic: false }));
            dispatch(
                addNotification([
                    {
                        title: notificationHomechargerAdded,
                        srOnly: true,
                    },
                ]),
            );
        }
    };

    return (
        <div
            className={clsx(cardStyles.card, cardStyles.clickable, styles.item, isSelected ? cardStyles.active : null)}
            onClick={handleClick}
        >
            <div>
                <figure className={styles["item-image"]}>
                    <img
                        {...getCarDBAssetSrcSet(
                            commonSettings,
                            [
                                { width: 172, height: 172 },
                                { width: 224, height: 224 },
                                { width: 344, height: 344 },
                                { width: 448, height: 448 },
                                { width: 894, height: 894 },
                            ],
                            image,
                        )}
                        width="172"
                        height="172"
                        sizes="(max-width: 1199px) 100vw,(max-width: 1448px) 172px, 224px"
                        alt={name}
                        loading="lazy"
                    />
                </figure>

                <div>
                    <Text variant="apheleia-h5" spacing="spacing-1">
                        {name}
                    </Text>
                    <Text variant="apheleia-body" spacing="spacing-1">
                        {footNote}
                    </Text>
                </div>

                {description && <div className={styles.rte} dangerouslySetInnerHTML={{ __html: description }} />}
            </div>
            <div className={styles.price}>
                <Text variant="apheleia-price">
                    <Price price={price} forceCashPrice />
                </Text>
                <AddToBasket
                    itemName={name}
                    active={isSelected ?? false}
                    onClick={handleClick}
                    checkType
                    className={cardStyles.indicator}
                />
            </div>
        </div>
    );
};

export default HomeCharger;
